import { cloneElement, Children } from 'react';
import { useSelector } from 'react-redux';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';

import classes from './classes.module.scss';

import {
  selectViewportMobile
} from 'app/reducers/viewportReducer';

const Modal2 = props => {
  const {
    title,
    subTitle,
    open,
    onClose,
    modalStyle,
    paperStyle,
    keepMounted
  } = props;

  const headerVariant = props.headerVariant || "h5";

  // here if needed
  //const isMobile = useSelector(state => state.portalReducer.isMobile);

  let headerIcon = null;
  if (props.headerIcon) {
    headerIcon = cloneElement(props.headerIcon, { className: classes.headerIcon });
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      className={classes.modal}
      style={modalStyle}
      keepMounted={keepMounted}
    >
      <Box className={classes.paper} style={paperStyle}>
        <CloseIcon className={classes.closeIcon} onClick={onClose} />
        <div className={classes.header}>
          {headerIcon}
          <div className={classes.titles}>
            <Typography variant={headerVariant} className={classes.title}>
              {title}
            </Typography>
            <Typography className={classes.subTitle}>
              {subTitle}
            </Typography>
          </div>
        </div>
        <hr />
        {Children.map(props.children, child => {
          // pass onClose to the child component so that it can close the modal,
          // unless that child component already has onClose defined.
          // this would be the case if there's a Modal inside of a Modal,
          // we don't want to override the inner Modal's onClose prop.
          // because of this, the inner modal won't be able to directly
          // close the outer modal
          if (child && !child.props.onClose) {
            return cloneElement(child, { onClose });
          } else {
            return child;
          }
        })}
      </Box>
    </Modal>
  );
}

export default Modal2;
